


































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import EchartsHumi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
// import echarts from 'Echarts'
Vue.prototype.$echarts = Echarts;
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date = new Date();
  mac:String;
  locationName: String;
  StartDate:Date = new Date();
  EndDate:Date=new Date();
}
@Component({
  components: { Echarts, EchartsHumi },
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date }) EndTime: Date;
  @Prop({ type: String }) mac: String;
  @Prop({ type: String }) locationName: String;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  humiseriesdata: string = "";
  yAxisdata: string = "";
  serieslist = [];
  humiserieslist = [];
  humistrtitle: string = "";
  yAxislist = [];
  thdata: Thdata = new Thdata();
  StartTime: string;
  list = [];
  strtitle: string = "";
  title: string = "数据分析";
  tempmessage: string = "";
  humimessage: string = "";
  datetype:string='day';
  startDate:Date=new Date();
  endDate:Date=new Date();
  monthDate:Date=new Date();
  polar:string="";
  maxtemp:string="";
  mintemp:string="";
  maxhumi:string="";
  minhumi:string="";
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime = this.EndTime;
    this.pagerequest.StartDate = this.EndTime;
    this.pagerequest.EndDate = this.EndTime;
    this.pagerequest.mac = this.mac;
    this.list = await this.$store.dispatch({
      type: "thdata/getPagedLast",
      data: this.pagerequest,
    });
    //this.ThisThPaged();
    this.strtitle = "温度走势图";
    this.humistrtitle = "湿度走势图";
    let titlelist = ["温湿度"];

    this.serieslist.push({
      name: "温度",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
    });
    this.humiserieslist.push({
      name: "湿度",
      type: "line",
      data: [],
      areaStyle: {opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false}
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      
    })

    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_temp1 = [];
    let datalist_humi1 = [];

    for (let entry of this.list) {
      //debugger
      // if(entry.pNo==1){
      //   timelist.push(this.GetMinutes(entry.addTime));
      //   datalist_temp1.push(entry.temp);
      //   datalist_humi1.push(entry.humi);
      // }else if(entry.pNo==2){
      //   datalist_temp2.push(entry.temp);
      //   datalist_humi2.push(entry.humi);
      // }else if(entry.pNo==3){
      //   datalist_temp3.push(entry.temp);
      //   datalist_humi3.push(entry.humi);
      // }
      timelist.push(this.GetDays(entry.addTime)+" "+this.GetMinutes(entry.addTime));
      datalist_temp1.push(entry.temp1);
      datalist_humi1.push(entry.humi1);
    }
    this.tempmessage = datalist_temp1[datalist_temp1.length - 1];
    this.humimessage = datalist_humi1[datalist_temp1.length - 1];
    
    this.serieslist[0].data = datalist_temp1;
    this.humiserieslist[0].data = datalist_humi1;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
  async getThreshold(){
    var thresholdId;
    this.pagerequest.mac = this.mac;
    var elist = await this.$store.dispatch({
      type: "thequipment/getPageBymac",
      data: this.pagerequest,
    });

    if(elist.length > 0&&elist[0].tId!=''){
      thresholdId=elist[0].tId;
    }else{
      thresholdId='4'
    }
     var threshold = await this.$store.dispatch({
      type: "ththreshold/get",
      id: thresholdId
    });
     this.maxtemp=threshold.maxtemp;
     this.mintemp=threshold.mintemp;
     this.maxhumi=threshold.maxhumi;
     this.minhumi=threshold.minhumi;
  }
  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
   GetDays(time) {
    let date = new Date(time);
    let Str =this.GetBqMinutes(date.getMonth()+1)+"."+this.GetBqMinutes(date.getDate()) ;
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();
    
    if (!value) {
      this.$emit("input", value);
      this.$emit("title", this.locationName);
    } else {
      this.getPage();
      this.getThreshold();
    }
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }
  GetByDate(){
    if(this.pagerequest.StartDate.toString()!=""&&this.pagerequest.EndDate.toString()!=""){
      //  this.pagerequest.StartDate=this.startDate;
      //  this.pagerequest.EndDate=this.endDate;
       this.pagerequest.mac = this.mac;
       this.GetPageByDate();
    }
    
  }
  GetByMonth(){
    if(this.monthDate.toString()!=""){
    var currentY = this.monthDate.getFullYear();
    var currentM = this.monthDate.getMonth()+1;
    var lastM = new Date(currentY,currentM,0);
    var lastS = new Date(currentY,currentM-1);
    this.pagerequest.StartDate=lastS;
    this.pagerequest.EndDate=lastM;
    this.pagerequest.mac = this.mac;
    this.GetPageByDate();
    }
    
  }
  async GetPageByDate(){
    this.list = await this.$store.dispatch({
      type: "thdata/getPageByDate",
      data: this.pagerequest,
    });
    this.strtitle = "温度走势图";
    this.humistrtitle = "湿度走势图";
    let titlelist = ["温湿度"];

     this.serieslist.push({
      name: "温度",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false
        }
        
      },
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
    });
    this.humiserieslist.push({
      name: "湿度",
      type: "line",
      data: [],
      areaStyle: {opacity: 0.8,
        color: {
          colorStops: [{ 
            offset: 0,
             color: "rgba(1,191,236)"
          },{ 
            offset: 1,
            color: "rgba(84, 112, 198)"
           
          }
          ],
           x: 0,
           y: 0,
           x2: 0,
           y2: 1,
          type: "linear",
          global:false},
      markPoint: {
                data: [
                    {type: 'max', name: '最大值'},
                    {type: 'min', name: '最小值'}
                ]
            },
      }
    })

    let timelist = [];
    let datalist_temp1 = [];
    let datalist_humi1 = [];

    for (let entry of this.list) {
      timelist.push(this.GetDays(entry.addTime)+" "+this.GetMinutes(entry.addTime));
      datalist_temp1.push(entry.temp1);
      datalist_humi1.push(entry.humi1);
    }
    this.serieslist[0].data = datalist_temp1;
    this.humiserieslist[0].data = datalist_humi1;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }

}
